import type { ValidationLabels } from "../../utils/validationMessages";
import { ReportSnapshotTable } from "./ReportSnapshotTable";

// Section 6 of the sheet, the inputs (§19 result-first, §20 "inputs, units, sources,
// assumptions"): the stored input snapshot through the module's form label map - the names a
// user reads - with every value exactly as stored (the exact decimal strings) and its unit.
// Collapsed on screen after the results; the report page opens it for print (commit 8).

type ReportInputsProps = {
  snapshot: Record<string, unknown>;
  labels: ValidationLabels;
  open?: boolean;
};

export function ReportInputs({ snapshot, labels, open = false }: ReportInputsProps) {
  return (
    <details data-report-section="inputs" open={open}>
      <summary>Inputs</summary>
      <ReportSnapshotTable snapshot={snapshot} labels={labels} caption="Stored inputs" />
    </details>
  );
}

export default ReportInputs;
